import { verify2Fa } from '@/api/login';
import { setToken } from '@/libs/auth';
export default {
  name: 'VerifyTwofa',
  data: function data() {
    return {
      dialog: false,
      form: {
        twofa_token: '',
        verification_code: ''
      },
      rules: {
        verification_code: [{
          min: 6,
          max: 6,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open(token) {
      this.dialog = true;
      this.form.twofa_token = token;
    },
    close2FA: function close2FA() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          verify2Fa(_this.form).then(function (data) {
            _this.dialog = true;
            _this.resetForm();
            setToken(data.data.access_token);
            _this.$emit('login-success');
          }).catch(function () {
            _this.$notify({
              title: 'Fail',
              message: 'Google verification code error',
              type: 'warning'
            });
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(form) {
      this.dialog = false;
      this.$refs['form'].resetFields();
    }
  }
};